// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import {
//     PieChart, Pie, Cell,
//     LineChart, Line,
//     BarChart, Bar,
//     XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, AreaChart,
//     Area,
// } from 'recharts';
// import { Dropdown, DropdownButton } from 'react-bootstrap';
// import { FiTrendingUp, FiTrendingDown, FiDollarSign, FiCreditCard, FiPieChart, FiCalendar, FiFileText } from 'react-icons/fi';
// import Swal from 'sweetalert2';
// import { ComposedChart } from 'recharts';

// const AccountDashboard = () => {
//     const [account, setAccount] = useState({});
//     const [selectedFilter, setSelectedFilter] = useState("financialYear");
//     const [isDateFilterVisible, setIsDateFilterVisible] = useState(false);
//     const [customDateRange, setCustomDateRange] = useState({
//         startDate: '',
//         endDate: ''
//     });
//     const [isLoading, setIsLoading] = useState(false);


//     const COLORS = ['#4F46E5', '#6366F1', '#818CF8', '#A5B4FC', '#C7D2FE'];
//     const EXPENSE_COLORS = ['#EF4444', '#F97316', '#F59E0B', '#10B981', '#3B82F6'];
//     const [corporateTaxData, setCorporateTaxData] = useState(null);

//     const prepareReceivablesData = () => {
//         if (!account.receivables) return [];
//         return Object.entries(account.receivables).map(([key, value]) => ({
//             name: key,
//             value: value.reduce((sum, invoice) => sum + (invoice.quot_total_amount - invoice.total_amount_received || 0), 0),
//             count: value.length
//         }));
//     };

//     const preparePayablesData = () => {
//         if (!account.payables) return [];
//         return Object.entries(account.payables).map(([date, transactions]) => ({
//             date,
//             amount: transactions.reduce((sum, txn) => sum + (txn.amount || 0), 0)
//         })).sort((a, b) => new Date(a.date) - new Date(b.date));
//     };

//     const prepareCashFlowData = () => {
//         if (!account.cash_flow) return [];
//         return account.cash_flow.map(item => ({
//             day: item.day,
//             month: item.month,
//             net_cash: parseFloat(item.net_cash),
//         }));
//     };

//     const prepareExpenseBreakdownData = () => {
//         if (!account.expense_breakdown) return [];
//         return account.expense_breakdown.map(item => ({
//             name: item.category?.name || 'Uncategorized',
//             value: item.total
//         }));
//     };

//     const getFinancialYear = () => {
//         const monthMap = {
//             January: '01',
//             February: '02',
//             March: '03',
//             April: '04',
//             May: '05',
//             June: '06',
//             July: '07',
//             August: '08',
//             September: '09',
//             October: '10',
//             November: '11',
//             December: '12'
//         };

//         try {
//             const storedFormData = JSON.parse(localStorage.getItem('formData'));
//             const fy = storedFormData?.financial_year; // e.g. "January - December"

//             if (fy && fy.includes('-')) {
//                 const [startMonthName, endMonthName] = fy.split('-').map(m => m.trim());
//                 const currentYear = new Date().getFullYear();

//                 const startMonth = monthMap[startMonthName];
//                 const endMonth = monthMap[endMonthName];

//                 if (!startMonth || !endMonth) return { startDate: null, endDate: null };

//                 // If start month is later in the year than end, it's a cross-year range (e.g. April - March)
//                 const startYear = startMonth > endMonth ? currentYear - 1 : currentYear;
//                 const endYear = startMonth > endMonth ? currentYear : currentYear;

//                 const startDate = `${startYear}-${startMonth}-01`;
//                 const endDate = `${endYear}-${endMonth}-${new Date(endYear, parseInt(endMonth), 0).getDate()}`;

//                 return { startDate, endDate };
//             }
//         } catch (e) {
//             console.error("Failed to parse financial year:", e);
//         }

//         return { startDate: null, endDate: null };
//     };

//     console.log("getFinancialYear called", getFinancialYear());


//     const handleFinancialYearChange = (selectedYear) => {
//         if (selectedYear === "financialYear") {
//             setSelectedFilter("financialYear");
//             setIsDateFilterVisible(false);
//             const { startDate, endDate } = getFinancialYear();
//             fetchAccount(startDate, endDate);
//             fetchCorporateTax(startDate, endDate);
//         } else {
//             setSelectedFilter("customRange");
//             setIsDateFilterVisible(true);
//             setCustomDateRange({ startDate: '', endDate: '' });
//         }
//     };

//     const handleDateChange = (e) => {
//         const { name, value } = e.target;
//         setCustomDateRange(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleClearDates = () => {
//         setCustomDateRange({ startDate: '', endDate: '' });
//         setIsDateFilterVisible(false);
//         fetchAccount(null, null);
//         fetchCorporateTax(null, null);
//     };

//     // const handleSubmit = () => {
//     //     const { startDate, endDate } = customDateRange;
//     //     if (startDate && endDate) {
//     //         fetchAccount(startDate, endDate);
//     //         setIsDateFilterVisible(false);
//     //         if (selectedFilter === "customRange") {
//     //             fetchCorporateTax(startDate, endDate);
//     //         } else {
//     //             const fyDates = getFinancialYear();
//     //             fetchCorporateTax(fyDates.startDate, fyDates.endDate);
//     //         }
//     //     }
//     // };
//     const handleSubmit = () => {
//         const { startDate, endDate } = customDateRange;

//         fetchAccount(startDate || null, endDate || null);

//         if (selectedFilter === "customRange") {
//             fetchCorporateTax(startDate || null, endDate || null);
//         } else {
//             const fyDates = getFinancialYear();
//             fetchCorporateTax(fyDates.startDate || null, fyDates.endDate || null);
//         }

//         setIsDateFilterVisible(false);
//     };


//     const fetchAccount = async (startDate, endDate) => {
//         setIsLoading(true);
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/dashboard/account`, {
//                 params: {
//                     start_date: startDate,
//                     end_date: endDate,
//                 },
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             setAccount(response.data);
//         } catch (error) {
//             console.error("Error fetching data:", error.response?.data || error.message);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     // useEffect(() => {
//     //     fetchAccount();
//     //     const { startDate, endDate } = getFinancialYear();
//     //     if (startDate && endDate) {
//     //         fetchCorporateTax(startDate, endDate);
//     //     }
//     // }, []);
//     useEffect(() => {
//         fetchAccount();

//         const { startDate, endDate } = getFinancialYear();
//         console.log("Financial year dates being used:", startDate, endDate);

//         if (startDate && endDate) {
//             fetchCorporateTax(startDate, endDate);
//         } else {
//             console.warn("⚠️ No valid financial year found, falling back to current calendar year");
//             const year = new Date().getFullYear();
//             fetchCorporateTax(`${year}-01-01`, `${year}-12-31`);
//         }
//     }, []);


//     const AedSymbol = ({ size = '1em', color = 'currentColor' }) => (
//         <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width={size}
//             height={size}
//             viewBox="0 0 24 24"
//             fill={color}
//             style={{ verticalAlign: 'middle' }}
//         >
//             <path d="M8 4v16M16 4v16M4 8h16M4 16h16" />
//         </svg>
//     );


//     const formatCurrency = (amount = 0) => (
//         <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
//             <img
//                 src="/images/uae-dirham-symbol.png"
//                 alt="AED"
//                 style={{ width: '1em', verticalAlign: 'middle' }}
//             />
//             {new Intl.NumberFormat('en-AE', {
//                 style: 'decimal',
//                 maximumFractionDigits: 2,
//             }).format(amount)}
//         </span>
//     );



//     // const formatCurrency = (amount) => (
//     //   <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
//     //     <AedSymbol />
//     //     {new Intl.NumberFormat('en-AE', {
//     //       style: 'decimal',
//     //       maximumFractionDigits: 0,
//     //     }).format(amount || 0)}
//     //   </span>
//     // );

//     //     const formatCurrency = (amount) => {
//     //         // return new Intl.NumberFormat('ar-AE', {
//     //         //     style: 'currency',
//     //         //     currency: 'AED',
//     //         //     maximumFractionDigits: 0
//     //         // }).format(amount || 0).replace('₹', '₹ ');
//     //         <>
//     //     <AedSymbol />
//     //     {new Intl.NumberFormat('en-AE', {
//     //       style: 'decimal',
//     //       maximumFractionDigits: 0
//     //     }).format(amount || 0)}
//     //   </>
//     //     };
//     const checkVatPaymentDue = () => {
//         if (!account.tax_summary) return;

//         const today = new Date();
//         today.setHours(0, 0, 0, 0);
//         const taxSummary = Array.isArray(account.tax_summary) ? account.tax_summary : [account.tax_summary];

//         taxSummary.forEach(due => {
//             const dueDate = new Date(due.due_date);
//             dueDate.setHours(0, 0, 0, 0);

//             // Calculate days remaining (20 days before due date)
//             const daysRemaining = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));
//             console.log("Due Date:", dueDate);
//             console.log("Today's Date:", today);
//             console.log("Days Remaining:", daysRemaining);
//             const isPaid = localStorage.getItem(`${due.quarter}_${dueDate.toLocaleDateString()}`);
//             if (isPaid) {
//                 return; // If paid, skip showing the alert
//             }

//             // Show notification 20 days before due date
//             if (daysRemaining >= 0 && daysRemaining <= 20) {
//                 showVatDueAlert(due.quarter, dueDate, due.vat_payable);
//             }

//         });
//     };
//     const showVatDueAlert = (quarter, dueDate, amount) => {
//         const formattedDate = dueDate.toLocaleDateString('en-US', {
//             weekday: 'long',
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//         });
//         const isPaid = localStorage.getItem(`${quarter}_${formattedDate}`); // We use formatted date or quarter+year as a key

//         if (isPaid) {
//             // If it's already marked as paid, do not show the alert.
//             return;
//         }

//         Swal.fire({
//             title: `VAT Payment Due for ${quarter}`,
//             html: `
//                 <div style="text-align: left;">
//                     <p>You have <strong>${amount}</strong> VAT payable .</p>
//                     <p>Due date: <strong>${formattedDate}</strong></p>
//                     <p style="color: #dc3545;">Please make the payment before the due date to avoid penalties.</p>
//                 </div>
//             `,
//             icon: 'warning',
//             position: 'top-end',
//             timer: 10000, // 10 seconds
//             timerProgressBar: false,
//             showConfirmButton: true,
//             confirmButtonText: 'Mark as Paid',
//             showCancelButton: true,
//             cancelButtonText: 'Remind Me Later',
//             toast: true,
//             width: '450px',
//             customClass: {
//                 popup: 'vat-due-alert',
//                 title: 'vat-alert-title',
//                 htmlContainer: 'vat-alert-body',
//             }
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 localStorage.setItem(`${quarter}_${formattedDate}`, true);
//                 Swal.fire(
//                     'Payment Recorded!',
//                     'Your VAT payment has been marked as paid.',
//                     'success'
//                 );
//             }
//         });
//     };
//     useEffect(() => {
//         console.log("account.tax_summary changed", account.tax_summary);

//         if (account.tax_summary) {
//             checkVatPaymentDue();
//         }
//     }, [account.tax_summary]);
//     const fetchCorporateTax = async (fromDate, toDate) => {
//         try {
//             console.log("Fetching Corporate Tax with:", fromDate, toDate);

//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const token = JSON.parse(localStorage.getItem('user-info'))?.token;
//             const origin = localStorage.getItem('user-origin');
//             const API = process.env.REACT_APP_WEBZASH_URL;
//             const APIKEY = process.env.REACT_APP_API_KEY;

//             const response = await axios.get(`${API}/api/reports/corporate_tax`, {
//                 headers: {

//                     'x-api-key': APIKEY,

//                 },
//                 params: {
//                     startdate: fromDate,
//                     enddate: toDate
//                 }
//             });

//             setCorporateTaxData(response.data?.data);
//         } catch (error) {
//             console.error("Error fetching corporate tax data:", error);
//         }
//     };
//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">
//                                     Dashboard
//                                 </h4>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="dashboard-container">
//                         <div className="finance-dashboard">
//                             {/* Dashboard Header */}
//                             <div>


//                                 <div className="d-flex justify-content-end align-items-center mb-3">
//                                     <DropdownButton
//                                         id="financial-year-dropdown"
//                                         title={selectedFilter === "financialYear" ? 'This Financial Year' : 'Custom Range'}
//                                         onSelect={handleFinancialYearChange}
//                                         variant="outline-primary"
//                                         className="filter-dropdown"
//                                     >
//                                         <Dropdown.Item eventKey="financialYear">
//                                             <FiCalendar className="me-2" /> This Financial Year
//                                         </Dropdown.Item>
//                                         <Dropdown.Item eventKey="custom">
//                                             <FiCalendar className="me-2" /> Custom Range
//                                         </Dropdown.Item>
//                                     </DropdownButton>

//                                     {isDateFilterVisible && (
//                                         <div className="date-range-selector">
//                                             <input
//                                                 type="month"
//                                                 name="startDate"
//                                                 value={customDateRange.startDate}
//                                                 onChange={handleDateChange}
//                                                 className="form-control date-input"
//                                             />
//                                             <span className="date-separator">to</span>
//                                             <input
//                                                 type="month"
//                                                 name="endDate"
//                                                 value={customDateRange.endDate}
//                                                 onChange={handleDateChange}
//                                                 className="form-control date-input"
//                                             />
//                                             <button
//                                                 onClick={handleClearDates}
//                                                 className="btn btn-outline-secondary"
//                                             >
//                                                 Clear
//                                             </button>
//                                             <button
//                                                 onClick={handleSubmit}
//                                                 className="btn btn-primary"
//                                                 disabled={!customDateRange.startDate || !customDateRange.endDate}
//                                             >
//                                                 Apply
//                                             </button>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>


//                             <>
//                                 {/* Key Financial Metrics */}
//                                 <div className="metrics-grid">
//                                     <div>
//                                         <div className="metric-card">

//                                             <div className="metric-icon2 success">
//                                                 <FiTrendingUp size={24} />
//                                             </div>
//                                             <div className="metric-content">
//                                                 <h3>Total Revenue</h3>
//                                                 <p>{(corporateTaxData?.total_income)}</p>
//                                             </div>
//                                         </div>
//                                     </div>


//                                     <div >
//                                         <div className="metric-card">
//                                             <div className="metric-icon2 danger">
//                                                 <FiTrendingDown size={24} />
//                                             </div>
//                                             <div className="metric-content">
//                                                 <h3>Total Expenses</h3>
//                                                 <p>{(corporateTaxData?.total_expense)}</p>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div >
//                                         <div className="metric-card">
//                                             <div className="metric-icon2 primary">
//                                                 <FiDollarSign size={24} />
//                                             </div>
//                                             <div className="metric-content">
//                                                 <h3>Net Profit</h3>
//                                                 <p className={corporateTaxData?.net_profit >= 0 ? 'text-success' : 'text-danger'}>
//                                                     {(corporateTaxData?.net_profit)}
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div >
//                                         <div className="metric-card">
//                                             <div className="metric-icon2 warning">
//                                                 <FiCreditCard size={24} />
//                                             </div>
//                                             <div className="metric-content">
//                                                 <h3>Trial Balance</h3>
//                                                 <p>{(Math.abs((account.trial_balance?.debits || 0) - (account.trial_balance?.credits || 0)))}</p>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Main Content Area */}
//                                 <div className="dashboard-content">
//                                     {/* First Row */}
//                                     <div className="row">
//                                         <div className="col-lg-6">
//                                             <div className="card2">
//                                                 <div className="card-header">
//                                                     <h3>Revenue, Expense & Profit Overview</h3>
//                                                 </div>
//                                                 <div className="card-body">
//                                                     {corporateTaxData ? (
//                                                         <div className="chart-container">
//                                                             <ResponsiveContainer width="100%" height={300}>
//                                                                 <ComposedChart
//                                                                     data={[
//                                                                         {
//                                                                             name: 'Financial Summary',
//                                                                             revenue: corporateTaxData?.total_income || 0,
//                                                                             expense: corporateTaxData?.total_expense || 0,
//                                                                             profit: corporateTaxData?.net_profit || 0
//                                                                         }
//                                                                     ]}
//                                                                     margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
//                                                                 >
//                                                                     <CartesianGrid strokeDasharray="3 3" />
//                                                                     <XAxis dataKey="name" />
//                                                                     <YAxis
//                                                                         tickFormatter={(value) => `${value}`}
//                                                                     />
//                                                                     <Tooltip
//                                                                         formatter={(value, name) => [
//                                                                             formatCurrency(value),
//                                                                             name === 'revenue' ? 'Revenue' :
//                                                                                 name === 'expense' ? 'Expense' : 'Profit'
//                                                                         ]}
//                                                                     />
//                                                                     <Legend
//                                                                         formatter={(value) =>
//                                                                             value === 'revenue' ? 'Revenue' :
//                                                                                 value === 'expense' ? 'Expense' : 'Profit'
//                                                                         }
//                                                                     />
//                                                                     <Bar
//                                                                         dataKey="revenue"
//                                                                         name="revenue"
//                                                                         fill="#10B981"
//                                                                         barSize={40}
//                                                                         radius={[4, 4, 0, 0]}
//                                                                     />
//                                                                     <Bar
//                                                                         dataKey="expense"
//                                                                         name="expense"
//                                                                         fill="#EF4444"
//                                                                         barSize={40}
//                                                                         radius={[4, 4, 0, 0]}
//                                                                     />
//                                                                     <Bar
//                                                                         dataKey="profit"
//                                                                         name="profit"
//                                                                         fill="#3B82F6"
//                                                                         barSize={40}
//                                                                         radius={[4, 4, 0, 0]}
//                                                                     />
//                                                                 </ComposedChart>
//                                                             </ResponsiveContainer>
//                                                         </div>
//                                                     ) : (
//                                                         <div className="empty-state">
//                                                             <FiTrendingUp size={48} className="empty-icon" />
//                                                             <p>No financial data available</p>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         {/* Accounts Receivable */}
//                                         <div className="col-lg-6">
//                                             <div className="card2">
//                                                 <div className="card-header">
//                                                     <h3>Accounts Receivable</h3>
//                                                     <div className="card-actions">
//                                                         <span className="badge bg-primary">Outstanding</span>
//                                                     </div>
//                                                 </div>
//                                                 <div className="card-body">
//                                                     {prepareReceivablesData().some(item => item.value > 0) ? (
//                                                         <div className="chart-container">
//                                                             <ResponsiveContainer width="100%" height={300}>
//                                                                 <PieChart>
//                                                                     <Pie
//                                                                         data={prepareReceivablesData().filter(item => item.value > 0)}
//                                                                         dataKey="value"
//                                                                         nameKey="name"
//                                                                         cx="50%"
//                                                                         cy="50%"
//                                                                         outerRadius={80}
//                                                                         innerRadius={50}
//                                                                         label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
//                                                                     >
//                                                                         {prepareReceivablesData()
//                                                                             .filter(item => item.value > 0)
//                                                                             .map((entry, index) => (
//                                                                                 <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                                                                             ))}
//                                                                     </Pie>
//                                                                     <Tooltip formatter={(value) => (value)} />
//                                                                 </PieChart>
//                                                             </ResponsiveContainer>
//                                                         </div>
//                                                     ) : (
//                                                         <div className="empty-state">
//                                                             <FiPieChart size={48} className="empty-icon" />
//                                                             <p>No outstanding receivables</p>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* Cash Flow */}

//                                     </div>

//                                     {/* Second Row */}
//                                     <div className="row">
//                                         {/* <div className="col-lg-4">
//                                             <div className="tax-summary-card">
//                                                 <div className="card2">
//                                                     <div className="card-header">
//                                                         <h3>VAT Summary</h3>
//                                                         {account.tax_summary?.quarter && (
//                                                             <div className="card-actions">
//                                                                 <span className="badge bg-info">{account.tax_summary.quarter}</span>
//                                                                 <span className="period-badge">{account.tax_summary.period}</span>
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                     <div className="card-body">
//                                                         {account.tax_summary ? (
//                                                             <div className="tax-summary-grid">
//                                                                 <div className="tax-item input-vat">
//                                                                     <div className="tax-label">Output VAT</div>
//                                                                     <div className="tax-value">{(account.tax_summary.input_vat)}</div>
//                                                                 </div>

//                                                                 <div className="tax-item output-vat">
//                                                                     <div className="tax-label">Input VAT</div>
//                                                                     <div className="tax-value">{(account.tax_summary.output_vat)}</div>
//                                                                 </div>

//                                                                 <div className="tax-item payable">
//                                                                     <div className="tax-label">VAT Payable</div>
//                                                                     <div className="tax-value">{(account.tax_summary.vat_payable)}</div>

//                                                                 </div>
//                                                             </div>
//                                                         ) : (
//                                                             <div className="empty-state">
//                                                                 <FiFileText size={48} className="empty-icon" />
//                                                                 <p>No tax data available for this period</p>
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                         </div> */}

//                                         {/* VAT Summary */}
//                                         <div className="col-lg-4">
//                                             <div className="tax-summary-card">
//                                                 <div className="card2">
//                                                     <div className="card-header">
//                                                         <h3>VAT Summary</h3>
//                                                         {(account.tax_summary?.quarter || corporateTaxData) && (
//                                                             <div className="card-actions">
//                                                                 <span className="badge bg-info">
//                                                                     {account.tax_summary?.quarter || 'Custom Period'}
//                                                                 </span>
//                                                                 <span className="period-badge">
//                                                                     {account.tax_summary?.period || `${customDateRange.startDate} to ${customDateRange.endDate}`}
//                                                                 </span>
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                     <div className="card-body">
//                                                         {/* Use corporate tax data if account tax summary is empty/null */}
//                                                         {corporateTaxData && (!account.tax_summary || Object.keys(account.tax_summary).length === 0) ? (
//                                                             <div className="tax-summary-grid">
//                                                                 <div className="tax-item input-vat">
//                                                                     <div className="tax-label">Input VAT</div>
//                                                                     <div className="tax-value">{(corporateTaxData?.input_vat || 0)}</div>
//                                                                 </div>

//                                                                 <div className="tax-item output-vat">
//                                                                     <div className="tax-label">Output VAT</div>
//                                                                     <div className="tax-value">{(corporateTaxData?.output_vat || 0)}</div>
//                                                                 </div>

//                                                                 <div className="tax-item payable">
//                                                                     <div className="tax-label">VAT Payable</div>
//                                                                     <div className="tax-value">{(corporateTaxData?.vat_payable || 0)}</div>
//                                                                 </div>
//                                                             </div>
//                                                         ) : account.tax_summary ? (
//                                                             // Use normal account tax summary data
//                                                             <div className="tax-summary-grid">
//                                                                 <div className="tax-item input-vat">
//                                                                     <div className="tax-label">Output VAT</div>
//                                                                     <div className="tax-value">{(account.tax_summary.input_vat)}</div>
//                                                                 </div>

//                                                                 <div className="tax-item output-vat">
//                                                                     <div className="tax-label">Input VAT</div>
//                                                                     <div className="tax-value">{(account.tax_summary.output_vat)}</div>
//                                                                 </div>

//                                                                 <div className="tax-item payable">
//                                                                     <div className="tax-label">VAT Payable</div>
//                                                                     <div className="tax-value">{(account.tax_summary.vat_payable)}</div>
//                                                                 </div>
//                                                             </div>
//                                                         ) : (
//                                                             <div className="empty-state">
//                                                                 <FiFileText size={48} className="empty-icon" />
//                                                                 <p>No tax data available for this period</p>
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-4">
//                                             <div className="card2">
//                                                 <div className="card-header">
//                                                     <h3>Expense Breakdown</h3>
//                                                 </div>
//                                                 <div className="card-body">
//                                                     {account.expense_breakdown?.length ? (
//                                                         <>
//                                                             <ResponsiveContainer width="100%" height={139}>
//                                                                 <PieChart>
//                                                                     <Pie
//                                                                         data={account.expense_breakdown.map(item => ({
//                                                                             name: item.category?.name || 'Uncategorized',
//                                                                             value: parseFloat(item.total)
//                                                                         }))}
//                                                                         dataKey="value"
//                                                                         nameKey="name"
//                                                                         cx="50%"
//                                                                         cy="50%"
//                                                                         outerRadius={70}
//                                                                         label={false}
//                                                                         stroke="none"            >
//                                                                         {account.expense_breakdown.map((entry, index) => (
//                                                                             <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                                                                         ))}
//                                                                     </Pie>
//                                                                     <Tooltip
//                                                                         formatter={(value) => (value)}
//                                                                     />
//                                                                 </PieChart>
//                                                             </ResponsiveContainer>

//                                                         </>
//                                                     ) : (
//                                                         <p className="text-muted">No expense data available</p>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* Upcoming Payment Dues */}
//                                         <div className="col-lg-4">
//                                             <div className="card2">
//                                                 <div className="card-header">
//                                                     <h3>VAT Payment Reminders</h3>
//                                                     <div className="card-actions">
//                                                         <span className="badge bg-warning">Upcoming Quarters</span>
//                                                     </div>
//                                                 </div>
//                                                 <div className="card-body">
//                                                     {account.upcoming_dues?.length ? (
//                                                         <div className="upcoming-dues-list">
//                                                             {account.upcoming_dues.map((due, index) => {
//                                                                 const dueDate = new Date(due.due_date);
//                                                                 const today = new Date();
//                                                                 const daysRemaining = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));

//                                                                 // Only show if within the reminder period (20 days before due date)
//                                                                 if (daysRemaining > 0 && daysRemaining <= 20) {
//                                                                     return (
//                                                                         <div key={index} className="due-item">
//                                                                             <div className="due-content">
//                                                                                 <div className="due-title">VAT Payment - {due.quarter}</div>
//                                                                                 <div className="due-date">
//                                                                                     Due: {dueDate.toLocaleDateString('en-US', {
//                                                                                         month: 'short',
//                                                                                         day: 'numeric',
//                                                                                         year: 'numeric'
//                                                                                     })}
//                                                                                 </div>
//                                                                             </div>
//                                                                             <div className="due-meta">
//                                                                                 <span className={`badge ${daysRemaining <= 7 ? 'bg-danger' : 'bg-warning'
//                                                                                     }`}>
//                                                                                     {daysRemaining} {daysRemaining === 1 ? 'day' : 'days'} left
//                                                                                 </span>
//                                                                             </div>
//                                                                         </div>
//                                                                     );
//                                                                 }
//                                                                 return null;
//                                                             }).filter(Boolean)}
//                                                         </div>
//                                                     ) : (
//                                                         <div className="empty-state">
//                                                             <FiCalendar size={48} className="empty-icon" />
//                                                             <p>No upcoming VAT payments within reminder period</p>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* Accounts Payable Trend */}

//                                         <div className="col-lg-4 mb-3">

//                                             <div className="card2">
//                                                 <div className="card-header">
//                                                     <h3>Accounts Payable Trend</h3>
//                                                 </div>
//                                                 <div className="card-body">
//                                                     <div className="chart-container">
//                                                         <ResponsiveContainer width="100%" height={300}>
//                                                             <BarChart data={preparePayablesData()}>
//                                                                 <CartesianGrid strokeDasharray="3 3" vertical={false} />
//                                                                 <XAxis dataKey="date" />
//                                                                 <YAxis />
//                                                                 <Tooltip formatter={(value) => (value)} />
//                                                                 <Bar
//                                                                     dataKey="amount"
//                                                                     fill="#EF4444"
//                                                                     radius={[4, 4, 0, 0]}
//                                                                 />
//                                                             </BarChart>
//                                                         </ResponsiveContainer>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-6">
//                                             <div className="card2">
//                                                 <div className="card-header">
//                                                     <h3>Cash Flow</h3>
//                                                 </div>
//                                                 <div className="card-body">
//                                                     <div className="chart-container">
//                                                         <ResponsiveContainer width="100%" height={300}>
//                                                             <AreaChart data={prepareCashFlowData()}>
//                                                                 <CartesianGrid strokeDasharray="3 3" />
//                                                                 <XAxis dataKey="day" tick={{ fontSize: 10 }} />
//                                                                 <YAxis
//                                                                     domain={['dataMin - 100', 'dataMax + 100']}
//                                                                     tickFormatter={(value) => `${value}`}
//                                                                 />
//                                                                 <Tooltip
//                                                                     formatter={(value) => [(value), 'Net Cash Flow']}
//                                                                     labelFormatter={(day) => `Day: ${day}`}
//                                                                 />
//                                                                 <Legend />
//                                                                 <Area
//                                                                     type="monotone"
//                                                                     dataKey="net_cash"
//                                                                     name="Net Cash Flow"
//                                                                     stroke="#4F46E5"
//                                                                     fill="#4F46E5"
//                                                                     fillOpacity={0.3}
//                                                                 />
//                                                             </AreaChart>
//                                                         </ResponsiveContainer>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </>
//                         </div>
//                     </div>
//                 </div>
//             </div>



//         </div>
//     );
// };

// export default AccountDashboard;




import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    PieChart, Pie, Cell,
    LineChart, Line,
    BarChart, Bar,
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, AreaChart,
    Area,
} from 'recharts';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { FiTrendingUp, FiTrendingDown, FiDollarSign, FiCreditCard, FiPieChart, FiCalendar, FiFileText } from 'react-icons/fi';
import Swal from 'sweetalert2';
import { ComposedChart } from 'recharts';

const AccountDashboard = () => {
    const [account, setAccount] = useState({});
    const [selectedFilter, setSelectedFilter] = useState("financialYear");
    const [isDateFilterVisible, setIsDateFilterVisible] = useState(false);
    const [customDateRange, setCustomDateRange] = useState({
        startDate: '',
        endDate: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [bankLedgers, setBankLedgers] = useState([]);
    const [totalBalance, setTotalBalance] = useState(0);
    const [payableBalance, setPayableBalance] = useState(0);
    const [actualBalance, setActualBalance] = useState(0);

    const COLORS = ['#4F46E5', '#6366F1', '#818CF8', '#A5B4FC', '#C7D2FE'];
    const EXPENSE_COLORS = ['#EF4444', '#F97316', '#F59E0B', '#10B981', '#3B82F6'];
    const [corporateTaxData, setCorporateTaxData] = useState(null);

    // Fetch Bank Ledgers with date parameters
    // const fetchBankLedgers = async (startDate = null, endDate = null) => {
    //     try {
    //         const Api = process.env.REACT_APP_WEBZASH_URL;
    //         const apiKey = process.env.REACT_APP_API_KEY;

    //         const params = {};
    //         if (startDate) params.startdate = startDate;
    //         if (endDate) params.enddate = endDate;

    //         const response = await axios.get(
    //             `${Api}/api/reports/balancesheet`,
    //             {
    //                 headers: {
    //                     'x-api-key': apiKey,
    //                     'Accept': 'application/json'
    //                 },
    //                 params: params
    //             }
    //         );

    //         const bankAsset = response.data.data.assets.find(
    //             (asset) => asset.name === 'Bank Accounts'
    //         );

    //         if (bankAsset && bankAsset.children) {
    //             setBankLedgers(bankAsset.children);

    //             // Total balance
    //             const total = bankAsset.children.reduce(
    //                 (sum, bank) => sum + parseFloat(bank.amount || 0),
    //                 0
    //             );
    //             setTotalBalance(total);

    //             // ✅ Use corporateTaxData.total_expense instead of API call
    //             const totalExpense = corporateTaxData?.total_expense || 0;
    //             setPayableBalance(totalExpense);

    //             // Actual available balance
    //             setActualBalance(total - totalExpense);
    //         } else {
    //             setBankLedgers([]);
    //             setTotalBalance(0);
    //             setPayableBalance(0);
    //             setActualBalance(0);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching bank ledgers:', error);
    //         setBankLedgers([]);
    //         setTotalBalance(0);
    //         setPayableBalance(0);
    //         setActualBalance(0);
    //     }
    // };
    const [cashInHandLedgers, setCashInHandLedgers] = useState([]);
    const [totalCashBalance, setTotalCashBalance] = useState(0);
    const [totalAssetBalance, setTotalAssetBalance] = useState(0);
    const fetchBankLedgers = async () => {
        try {
            const Api = process.env.REACT_APP_WEBZASH_URL;
            const apiKey = process.env.REACT_APP_API_KEY;

            // Fetch balance sheet data
            const responseLedger = await axios.get(`${Api}/api/reports/balancesheet`, {
                headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
            });

            console.log('Balance Sheet Data:', responseLedger.data.data);

            const assets = responseLedger.data.data.assets || [];
            const liabilities = responseLedger.data.data.liabilities || [];

            // Find Bank Accounts
            const bankAsset = assets.find(
                (asset) => asset.name === 'Bank Accounts'
            );

            // Find Cash in Hand
            const cashInHandAsset = assets.find(
                (asset) => asset.name === 'Cash-in-Hand'
            );

            // Find Payable Liabilities
            // These could include: Sundry Creditors (Vendors), Loans (Liabilities), etc.
            const sundryCreditors = liabilities.find(
                (liability) => liability.name === 'Sundry Creditors (Vendors)'
            );

            const loansLiabilities = liabilities.find(
                (liability) => liability.name === 'Loans (Liabilities)'
            );

            const currentLiabilities = liabilities.find(
                (liability) => liability.name === 'Current Liabilities'
            );

            const dutiesAndTaxes = liabilities.find(
                (liability) => liability.name === 'Duties and Taxes'
            );

            console.log('Bank Asset:', bankAsset);
            console.log('Cash in Hand Asset:', cashInHandAsset);
            console.log('Sundry Creditors:', sundryCreditors);
            console.log('Loans Liabilities:', loansLiabilities);

            let bankTotal = 0;
            let cashTotal = 0;
            let assetTotal = 0;
            let payableTotal = 0;

            // Calculate Bank Assets
            if (bankAsset && bankAsset.children) {
                console.log('Bank Children:', bankAsset.children);

                const bankItems = bankAsset.children.map(bank => {
                    const amount = parseFloat(bank.amount || 0);
                    // For ASSETS: Debit (D) = positive, Credit (C) = negative
                    const signedAmount = bank.dc === 'D' ? amount : -amount;

                    console.log(`Bank: ${bank.name}, Amount: ${amount}, DC: ${bank.dc}, Signed: ${signedAmount}`);

                    return {
                        ...bank,
                        signedAmount: signedAmount,
                        displayAmount: Math.abs(amount),
                        isDebit: bank.dc === 'D',
                        isCredit: bank.dc === 'C',
                        rawAmount: amount,
                        dc: bank.dc
                    };
                });

                setBankLedgers(bankItems);
                bankTotal = bankItems.reduce((sum, bank) => sum + bank.signedAmount, 0);
                setTotalBalance(bankTotal);

                console.log('Calculated Bank Total:', bankTotal);
            }

            // Calculate Cash Assets
            if (cashInHandAsset && cashInHandAsset.children) {
                console.log('Cash Children:', cashInHandAsset.children);

                const cashItems = cashInHandAsset.children.map(cash => {
                    const amount = parseFloat(cash.amount || 0);
                    // For ASSETS: Debit (D) = positive, Credit (C) = negative
                    const signedAmount = cash.dc === 'D' ? amount : -amount;

                    console.log(`Cash: ${cash.name}, Amount: ${amount}, DC: ${cash.dc}, Signed: ${signedAmount}`);

                    return {
                        ...cash,
                        signedAmount: signedAmount,
                        displayAmount: Math.abs(amount),
                        isDebit: cash.dc === 'D',
                        isCredit: cash.dc === 'C',
                        rawAmount: amount,
                        dc: cash.dc
                    };
                });

                setCashInHandLedgers(cashItems);
                cashTotal = cashItems.reduce((sum, cash) => sum + cash.signedAmount, 0);
                setTotalCashBalance(cashTotal);

                console.log('Calculated Cash Total:', cashTotal);
            }

            // Calculate Total Payables from Liabilities
            // For LIABILITIES: Credit (C) = positive (you owe money), Debit (D) = negative
            const calculateLiabilityTotal = (liability) => {
                if (!liability || !liability.children) return 0;

                return liability.children.reduce((sum, item) => {
                    const amount = parseFloat(item.amount || 0);
                    // For LIABILITIES: Credit (C) = positive (you owe), Debit (D) = negative
                    const signedAmount = item.dc === 'C' ? amount : -amount;
                    return sum + signedAmount;
                }, 0);
            };

            // Calculate total payables
            payableTotal =
                calculateLiabilityTotal(sundryCreditors) +
                calculateLiabilityTotal(loansLiabilities) +
                calculateLiabilityTotal(currentLiabilities) +
                calculateLiabilityTotal(dutiesAndTaxes);

            setPayableBalance(payableTotal);
            console.log('Total Payables (Liabilities):', payableTotal);

            // Calculate total asset balance (Bank + Cash)
            assetTotal = bankTotal + cashTotal;
            setTotalAssetBalance(assetTotal);

            console.log('Total Asset Balance (Bank + Cash):', assetTotal);

            // Actual balance = total assets (bank + cash) - total payables
            const actualBal = assetTotal - payableTotal;
            setActualBalance(actualBal);

            console.log('Actual Available Balance:', actualBal);

        } catch (error) {
            console.error('Error fetching assets or expenses:', error);
        }
    };
    const prepareReceivablesData = () => {
        if (!account.receivables) return [];
        return Object.entries(account.receivables).map(([key, value]) => ({
            name: key,
            value: value.reduce((sum, invoice) => sum + (invoice.quot_total_amount - invoice.total_amount_received || 0), 0),
            count: value.length
        }));
    };

    const preparePayablesData = () => {
        if (!account.payables) return [];
        return Object.entries(account.payables).map(([date, transactions]) => ({
            date,
            amount: transactions.reduce((sum, txn) => sum + (txn.amount || 0), 0)
        })).sort((a, b) => new Date(a.date) - new Date(b.date));
    };

    const prepareCashFlowData = () => {
        if (!account.cash_flow) return [];
        return account.cash_flow.map(item => ({
            day: item.day,
            month: item.month,
            net_cash: parseFloat(item.net_cash),
        }));
    };

    const prepareExpenseBreakdownData = () => {
        if (!account.expense_breakdown) return [];
        return account.expense_breakdown.map(item => ({
            name: item.category?.name || 'Uncategorized',
            value: item.total
        }));
    };

    const getFinancialYear = () => {
        const monthMap = {
            January: '01',
            February: '02',
            March: '03',
            April: '04',
            May: '05',
            June: '06',
            July: '07',
            August: '08',
            September: '09',
            October: '10',
            November: '11',
            December: '12'
        };

        try {
            const storedFormData = JSON.parse(localStorage.getItem('formData'));
            const fy = storedFormData?.financial_year;

            if (fy && fy.includes('-')) {
                const [startMonthName, endMonthName] = fy.split('-').map(m => m.trim());
                const currentYear = new Date().getFullYear();

                const startMonth = monthMap[startMonthName];
                const endMonth = monthMap[endMonthName];

                if (!startMonth || !endMonth) return { startDate: null, endDate: null };

                const startYear = startMonth > endMonth ? currentYear - 1 : currentYear;
                const endYear = startMonth > endMonth ? currentYear : currentYear;

                const startDate = `${startYear}-${startMonth}-01`;
                const endDate = `${endYear}-${endMonth}-${new Date(endYear, parseInt(endMonth), 0).getDate()}`;

                return { startDate, endDate };
            }
        } catch (e) {
            console.error("Failed to parse financial year:", e);
        }

        return { startDate: null, endDate: null };
    };

    const handleFinancialYearChange = (selectedYear) => {
        if (selectedYear === "financialYear") {
            setSelectedFilter("financialYear");
            setIsDateFilterVisible(false);
            const { startDate, endDate } = getFinancialYear();
            fetchAccount(startDate, endDate);
            fetchBankLedgers(startDate, endDate); // Update bank data with financial year
            fetchCorporateTax(startDate, endDate);
        } else {
            setSelectedFilter("customRange");
            setIsDateFilterVisible(true);
            setCustomDateRange({ startDate: '', endDate: '' });
        }
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setCustomDateRange(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleClearDates = () => {
        setCustomDateRange({ startDate: '', endDate: '' });
        setIsDateFilterVisible(false);
        fetchAccount(null, null);
        fetchBankLedgers(null, null); // Clear dates for bank data
        fetchCorporateTax(null, null);
    };

    const handleSubmit = () => {
        const { startDate, endDate } = customDateRange;
        fetchAccount(startDate || null, endDate || null);
        fetchBankLedgers(startDate || null, endDate || null); // Update bank data with custom dates

        if (selectedFilter === "customRange") {
            fetchCorporateTax(startDate || null, endDate || null);
        } else {
            const fyDates = getFinancialYear();
            fetchCorporateTax(fyDates.startDate || null, fyDates.endDate || null);
        }
        setIsDateFilterVisible(false);
    };

    const fetchAccount = async (startDate, endDate) => {
        setIsLoading(true);
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/dashboard/account`, {
                params: {
                    start_date: startDate,
                    end_date: endDate,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setAccount(response.data);
        } catch (error) {
            console.error("Error fetching data:", error.response?.data || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchAccount();
        fetchBankLedgers(); // Fetch bank data on component mount

        const { startDate, endDate } = getFinancialYear();
        console.log("Financial year dates being used:", startDate, endDate);

        if (startDate && endDate) {
            fetchCorporateTax(startDate, endDate);
        } else {
            console.warn("⚠️ No valid financial year found, falling back to current calendar year");
            const year = new Date().getFullYear();
            fetchCorporateTax(`${year}-01-01`, `${year}-12-31`);
        }
    }, []);

    const formatCurrency = (amount = 0) => (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
            <img
                src="/images/uae-dirham-symbol.png"
                alt="AED"
                style={{ width: '1em', verticalAlign: 'middle' }}
            />
            {new Intl.NumberFormat('en-AE', {
                style: 'decimal',
                maximumFractionDigits: 2,
            }).format(amount)}
        </span>
    );

    const checkVatPaymentDue = () => {
        if (!account.tax_summary) return;

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const taxSummary = Array.isArray(account.tax_summary) ? account.tax_summary : [account.tax_summary];

        taxSummary.forEach(due => {
            const dueDate = new Date(due.due_date);
            dueDate.setHours(0, 0, 0, 0);

            const daysRemaining = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));
            console.log("Due Date:", dueDate);
            console.log("Today's Date:", today);
            console.log("Days Remaining:", daysRemaining);
            const isPaid = localStorage.getItem(`${due.quarter}_${dueDate.toLocaleDateString()}`);
            if (isPaid) {
                return;
            }

            if (daysRemaining >= 0 && daysRemaining <= 20) {
                showVatDueAlert(due.quarter, dueDate, due.vat_payable);
            }
        });
    };

    const formatUSCurrency = (amount) => {
        if (!amount && amount !== 0) return '0.00';
        return parseFloat(amount).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    const showVatDueAlert = (quarter, dueDate, amount) => {
        const formattedDate = dueDate.toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        const isPaid = localStorage.getItem(`${quarter}_${formattedDate}`);

        if (isPaid) {
            return;
        }

        Swal.fire({
            title: `VAT Payment Due for ${quarter}`,
            html: `
                <div style="text-align: left;">
                    <p>You have <strong>${amount}</strong> VAT payable .</p>
                    <p>Due date: <strong>${formattedDate}</strong></p>
                    <p style="color: #dc3545;">Please make the payment before the due date to avoid penalties.</p>
                </div>
            `,
            icon: 'warning',
            position: 'top-end',
            timer: 10000,
            timerProgressBar: false,
            showConfirmButton: true,
            confirmButtonText: 'Mark as Paid',
            showCancelButton: true,
            cancelButtonText: 'Remind Me Later',
            toast: true,
            width: '450px',
            customClass: {
                popup: 'vat-due-alert',
                title: 'vat-alert-title',
                htmlContainer: 'vat-alert-body',
            }
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.setItem(`${quarter}_${formattedDate}`, true);
                Swal.fire(
                    'Payment Recorded!',
                    'Your VAT payment has been marked as paid.',
                    'success'
                );
            }
        });
    };

    useEffect(() => {
        console.log("account.tax_summary changed", account.tax_summary);

        if (account.tax_summary) {
            checkVatPaymentDue();
        }
    }, [account.tax_summary]);

    const fetchCorporateTax = async (fromDate, toDate) => {
        try {
            console.log("Fetching Corporate Tax with:", fromDate, toDate);

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const token = JSON.parse(localStorage.getItem('user-info'))?.token;
            const origin = localStorage.getItem('user-origin');
            const API = process.env.REACT_APP_WEBZASH_URL;
            const APIKEY = process.env.REACT_APP_API_KEY;

            const response = await axios.get(`${API}/api/reports/corporate_tax`, {
                headers: {
                    'x-api-key': APIKEY,
                    'Accept': 'application/json'
                },
                params: {
                    startdate: fromDate,
                    enddate: toDate
                }
            });

            setCorporateTaxData(response.data?.data);
        } catch (error) {
            console.error("Error fetching corporate tax data:", error);
        }
    };
    const [exchangeRate, setExchangeRate] = useState(3.67);
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">
                                    Dashboard
                                </h4>
                            </div>
                        </div>
                    </div>

                    <div className="dashboard-container">
                        <div className="finance-dashboard">
                            {/* Dashboard Header */}
                            <div>
                                <div className="d-flex justify-content-end align-items-center mb-3">
                                    <DropdownButton
                                        id="financial-year-dropdown"
                                        title={selectedFilter === "financialYear" ? 'This Financial Year' : 'Custom Range'}
                                        onSelect={handleFinancialYearChange}
                                        variant="outline-primary"
                                        className="filter-dropdown"
                                    >
                                        <Dropdown.Item eventKey="financialYear">
                                            <FiCalendar className="me-2" /> This Financial Year
                                        </Dropdown.Item>
                                        <Dropdown.Item eventKey="custom">
                                            <FiCalendar className="me-2" /> Custom Range
                                        </Dropdown.Item>
                                    </DropdownButton>

                                    {isDateFilterVisible && (
                                        <div className="date-range-selector">
                                            <input
                                                type="month"
                                                name="startDate"
                                                value={customDateRange.startDate}
                                                onChange={handleDateChange}
                                                className="form-control date-input"
                                            />
                                            <span className="date-separator">to</span>
                                            <input
                                                type="month"
                                                name="endDate"
                                                value={customDateRange.endDate}
                                                onChange={handleDateChange}
                                                className="form-control date-input"
                                            />
                                            <button
                                                onClick={handleClearDates}
                                                className="btn btn-outline-secondary"
                                            >
                                                Clear
                                            </button>
                                            <button
                                                onClick={handleSubmit}
                                                className="btn btn-primary"
                                                disabled={!customDateRange.startDate || !customDateRange.endDate}
                                            >
                                                Apply
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <>
                                {/* Key Financial Metrics */}
                                <div className="metrics-grid">
                                    <div>
                                        <div className="metric-card">
                                            <div className="metric-icon2 success">
                                                <FiTrendingUp size={24} />
                                            </div>
                                            <div className="metric-content">
                                                <h3>Total Revenue</h3>
                                                <p>{formatUSCurrency(corporateTaxData?.total_income)}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="metric-card">
                                            <div className="metric-icon2 danger">
                                                <FiTrendingDown size={24} />
                                            </div>
                                            <div className="metric-content">
                                                <h3>Total Expenses</h3>
                                                <p>{formatUSCurrency(corporateTaxData?.total_expense)}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="metric-card">
                                            <div className="metric-icon2 primary">
                                                <FiDollarSign size={24} />
                                            </div>
                                            <div className="metric-content">
                                                <h3>Net Profit</h3>
                                                <p className={corporateTaxData?.net_profit >= 0 ? 'text-success' : 'text-danger'}>
                                                    {formatUSCurrency(corporateTaxData?.net_profit)}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="metric-card">
                                            <div className="metric-icon2 warning">
                                                <FiCreditCard size={24} />
                                            </div>
                                            <div className="metric-content">
                                                <h3>Bank Balance</h3>
                                                <p> {(totalBalance - (corporateTaxData?.total_expense || 0)).toLocaleString("en-US", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Main Content Area */}
                                <div className="dashboard-content">
                                    {/* First Row */}
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="card2">
                                                <div className="card-header">
                                                    <h3>Revenue, Expense & Profit Overview</h3>
                                                </div>
                                                <div className="card-body">
                                                    {corporateTaxData ? (
                                                        <div className="chart-container">
                                                            <ResponsiveContainer width="100%" height={300}>
                                                                <ComposedChart
                                                                    data={[
                                                                        {
                                                                            name: 'Financial Summary',
                                                                            revenue: corporateTaxData?.total_income || 0,
                                                                            expense: corporateTaxData?.total_expense || 0,
                                                                            profit: corporateTaxData?.net_profit || 0
                                                                        }
                                                                    ]}
                                                                    margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                                                                >
                                                                    <CartesianGrid strokeDasharray="3 3" />
                                                                    <XAxis dataKey="name" />
                                                                    <YAxis
                                                                        tickFormatter={(value) => `${value}`}
                                                                    />
                                                                    <Tooltip
                                                                        formatter={(value, name) => [
                                                                            formatCurrency(value),
                                                                            name === 'revenue' ? 'Revenue' :
                                                                                name === 'expense' ? 'Expense' : 'Profit'
                                                                        ]}
                                                                    />
                                                                    <Legend
                                                                        formatter={(value) =>
                                                                            value === 'revenue' ? 'Revenue' :
                                                                                value === 'expense' ? 'Expense' : 'Profit'
                                                                        }
                                                                    />
                                                                    <Bar
                                                                        dataKey="revenue"
                                                                        name="revenue"
                                                                        fill="#10B981"
                                                                        barSize={40}
                                                                        radius={[4, 4, 0, 0]}
                                                                    />
                                                                    <Bar
                                                                        dataKey="expense"
                                                                        name="expense"
                                                                        fill="#EF4444"
                                                                        barSize={40}
                                                                        radius={[4, 4, 0, 0]}
                                                                    />
                                                                    <Bar
                                                                        dataKey="profit"
                                                                        name="profit"
                                                                        fill="#3B82F6"
                                                                        barSize={40}
                                                                        radius={[4, 4, 0, 0]}
                                                                    />
                                                                </ComposedChart>
                                                            </ResponsiveContainer>
                                                        </div>
                                                    ) : (
                                                        <div className="empty-state">
                                                            <FiTrendingUp size={48} className="empty-icon" />
                                                            <p>No financial data available</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Bank Accounts Summary */}
                                        <div className="col-lg-6">
                                            <div className="card2">
                                                <div className="card-header">
                                                    <h3>Bank Accounts Summary</h3>
                                                    <div className="card-actions">
                                                        <span className="badge bg-primary">Live Balance</span>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    {bankLedgers.length > 0 ? (
                                                        <div className="bank-summary-table">
                                                            <div className="table-responsive">
                                                                <table className="table table-sm table-borderless mb-0">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Bank Account</th>
                                                                            <th>Balance (AED)</th>

                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {bankLedgers.map((bank, index) => (
                                                                            <tr key={index} className="bank-row">
                                                                                <td>
                                                                                    <div className="d-flex align-items-center">
                                                                                        <div className="bank-icon me-2">
                                                                                            <FiCreditCard size={16} className="text-primary" />
                                                                                        </div>
                                                                                        <span className="bank-name">{bank.name}</span>
                                                                                    </div>
                                                                                </td>
                                                                                <td className="text-end">
                                                                                    <span className="balance-amount">
                                                                                        {parseFloat(bank.amount || 0).toLocaleString("en-US", {
                                                                                            minimumFractionDigits: 2,
                                                                                            maximumFractionDigits: 2
                                                                                        })}
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                    <tfoot>
                                                                        <tr className="fw-bold table-active">
                                                                            <td>TOTAL BALANCE</td>
                                                                            <td className="text-end">
                                                                                {totalBalance.toLocaleString("en-US", {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })}
                                                                            </td>
                                                                        </tr>
                                                                        {corporateTaxData?.total_expense > 0 && (
                                                                            <tr className="fw-bold text-danger">
                                                                                <td>PAYABLE BALANCE</td>
                                                                                <td className="text-end">
                                                                                                                                                        {formatUSCurrency(payableBalance)} AED

                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                        <tr className="fw-bold text-success">
                                                                            <td>ACTUAL AVAILABLE BALANCE</td>
                                                                            <td className="text-end">
                                                                                {(totalBalance - (corporateTaxData?.total_expense || 0)).toLocaleString("en-US", {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })}
                                                                            </td>
                                                                        </tr>
                                                                    </tfoot>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="empty-state">
                                                            <FiCreditCard size={48} className="empty-icon" />
                                                            <p>No bank accounts found</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Second Row */}
                                    <div className="row">
                                        {/* VAT Summary */}
                                        <div className="col-lg-4">
                                            <div className="tax-summary-card">
                                                <div className="card2">
                                                    <div className="card-header">
                                                        <h3>VAT Summary</h3>
                                                        {(account.tax_summary?.quarter || corporateTaxData) && (
                                                            <div className="card-actions">
                                                                <span className="badge bg-info">
                                                                    {account.tax_summary?.quarter || 'Custom Period'}
                                                                </span>
                                                                <span className="period-badge">
                                                                    {account.tax_summary?.period || `${customDateRange.startDate} to ${customDateRange.endDate}`}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="card-body">
                                                        {corporateTaxData && (!account.tax_summary || Object.keys(account.tax_summary).length === 0) ? (
                                                            <div className="tax-summary-grid">
                                                                <div className="tax-item input-vat">
                                                                    <div className="tax-label">Input VAT</div>
                                                                    <div className="tax-value">{(corporateTaxData?.input_vat || 0)}</div>
                                                                </div>

                                                                <div className="tax-item output-vat">
                                                                    <div className="tax-label">Output VAT</div>
                                                                    <div className="tax-value">{(corporateTaxData?.output_vat || 0)}</div>
                                                                </div>

                                                                <div className="tax-item payable">
                                                                    <div className="tax-label">VAT Payable</div>
                                                                    <div className="tax-value">{(corporateTaxData?.vat_payable || 0)}</div>
                                                                </div>
                                                            </div>
                                                        ) : account.tax_summary ? (
                                                            <div className="tax-summary-grid">
                                                                <div className="tax-item input-vat">
                                                                    <div className="tax-label">Output VAT</div>
                                                                    <div className="tax-value">{(account.tax_summary.input_vat)}</div>
                                                                </div>

                                                                <div className="tax-item output-vat">
                                                                    <div className="tax-label">Input VAT</div>
                                                                    <div className="tax-value">{(account.tax_summary.output_vat)}</div>
                                                                </div>

                                                                <div className="tax-item payable">
                                                                    <div className="tax-label">VAT Payable</div>
                                                                    <div className="tax-value">{(account.tax_summary.vat_payable)}</div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="empty-state">
                                                                <FiFileText size={48} className="empty-icon" />
                                                                <p>No tax data available for this period</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div className="card2">
                                                <div className="card-header">
                                                    <h3>Expense Breakdown</h3>
                                                </div>
                                                <div className="card-body">
                                                    {account.expense_breakdown?.length ? (
                                                        <>
                                                            <ResponsiveContainer width="100%" height={139}>
                                                                <PieChart>
                                                                    <Pie
                                                                        data={account.expense_breakdown.map(item => ({
                                                                            name: item.category?.name || 'Uncategorized',
                                                                            value: parseFloat(item.total)
                                                                        }))}
                                                                        dataKey="value"
                                                                        nameKey="name"
                                                                        cx="50%"
                                                                        cy="50%"
                                                                        outerRadius={70}
                                                                        label={false}
                                                                        stroke="none">
                                                                        {account.expense_breakdown.map((entry, index) => (
                                                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                                        ))}
                                                                    </Pie>
                                                                    <Tooltip
                                                                        formatter={(value) => (value)}
                                                                    />
                                                                </PieChart>
                                                            </ResponsiveContainer>
                                                        </>
                                                    ) : (
                                                        <p className="text-muted">No expense data available</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Upcoming Payment Dues */}
                                        <div className="col-lg-4">
                                            <div className="card2">
                                                <div className="card-header">
                                                    <h3>VAT Payment Reminders</h3>
                                                    <div className="card-actions">
                                                        <span className="badge bg-warning">Upcoming Quarters</span>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    {account.upcoming_dues?.length ? (
                                                        <div className="upcoming-dues-list">
                                                            {account.upcoming_dues.map((due, index) => {
                                                                const dueDate = new Date(due.due_date);
                                                                const today = new Date();
                                                                const daysRemaining = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));

                                                                if (daysRemaining > 0 && daysRemaining <= 20) {
                                                                    return (
                                                                        <div key={index} className="due-item">
                                                                            <div className="due-content">
                                                                                <div className="due-title">VAT Payment - {due.quarter}</div>
                                                                                <div className="due-date">
                                                                                    Due: {dueDate.toLocaleDateString('en-US', {
                                                                                        month: 'short',
                                                                                        day: 'numeric',
                                                                                        year: 'numeric'
                                                                                    })}
                                                                                </div>
                                                                            </div>
                                                                            <div className="due-meta">
                                                                                <span className={`badge ${daysRemaining <= 7 ? 'bg-danger' : 'bg-warning'
                                                                                    }`}>
                                                                                    {daysRemaining} {daysRemaining === 1 ? 'day' : 'days'} left
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                                return null;
                                                            }).filter(Boolean)}
                                                        </div>
                                                    ) : (
                                                        <div className="empty-state">
                                                            <FiCalendar size={48} className="empty-icon" />
                                                            <p>No upcoming VAT payments within reminder period</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Accounts Payable Trend */}
                                        <div className="col-lg-4 mb-3">
                                            <div className="card2">
                                                <div className="card-header">
                                                    <h3>Accounts Payable Trend</h3>
                                                </div>
                                                <div className="card-body">
                                                    <div className="chart-container">
                                                        <ResponsiveContainer width="100%" height={300}>
                                                            <BarChart data={preparePayablesData()}>
                                                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                                                <XAxis dataKey="date" />
                                                                <YAxis />
                                                                <Tooltip formatter={(value) => (value)} />
                                                                <Bar
                                                                    dataKey="amount"
                                                                    fill="#EF4444"
                                                                    radius={[4, 4, 0, 0]}
                                                                />
                                                            </BarChart>
                                                        </ResponsiveContainer>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-8">
                                            <div className="card2">
                                                <div className="card-header">
                                                    <h3>Cash Flow</h3>
                                                </div>
                                                <div className="card-body">
                                                    <div className="chart-container">
                                                        <ResponsiveContainer width="100%" height={300}>
                                                            <AreaChart data={prepareCashFlowData()}>
                                                                <CartesianGrid strokeDasharray="3 3" />
                                                                <XAxis dataKey="day" tick={{ fontSize: 10 }} />
                                                                <YAxis
                                                                    domain={['dataMin - 100', 'dataMax + 100']}
                                                                    tickFormatter={(value) => `${value}`}
                                                                />
                                                                <Tooltip
                                                                    formatter={(value) => [(value), 'Net Cash Flow']}
                                                                    labelFormatter={(day) => `Day: ${day}`}
                                                                />
                                                                <Legend />
                                                                <Area
                                                                    type="monotone"
                                                                    dataKey="net_cash"
                                                                    name="Net Cash Flow"
                                                                    stroke="#4F46E5"
                                                                    fill="#4F46E5"
                                                                    fillOpacity={0.3}
                                                                />
                                                            </AreaChart>
                                                        </ResponsiveContainer>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountDashboard;